export default "__VITE_ASSET__ec201958__"